import { addDeviceInGroup, addGroupInTree, changeGroupName, removeGroupFromTree, } from 'console/sortableDeviceTree/utils/node-menu-utils';
import { convertDeviceTreeForTreeData, deviceTreeWithLostDevices, expandingGroup, filterDeviceTreeFromDuplicates, filterDeviceTreeFromUnknownDevice, moveItem, } from 'console/sortableDeviceTree/utils/device-tree-utils';
import { replaceDevicesForTree } from 'console/sortableDeviceTree/utils/replace-devices-for-tree';
export const getTreeItems = (device_tree, devices) => replaceDevicesForTree(convertDeviceTreeForTreeData(deviceTreeWithLostDevices(device_tree, devices)), devices);
export const deviceTreeReducer = (device_tree, devices, action) => {
    switch (action.type) {
        case 'UPDATE_DEVICE_TREE_FROM_SERVER': {
            //Если обновление прилетает из ПО
            if (action.device_tree_update_time == null) {
                return filterDeviceTreeFromDuplicates(action.device_tree);
            }
            //Если обновление прилетает от web, но оно не последнее
            if (action.device_tree_update_time <= action.old_device_tree_update_time) {
                return filterDeviceTreeFromDuplicates(device_tree);
            }
            return filterDeviceTreeFromDuplicates(action.device_tree);
        }
        case 'ADD_GROUP_IN_DEVICE_TREE':
            return filterDeviceTreeFromUnknownDevice(filterDeviceTreeFromDuplicates(addGroupInTree(action.path, action.newTitle, getTreeItems(device_tree, devices), device_tree)), devices);
        case 'DELETE_GROUP_IN_DEVICE_TREE':
            return filterDeviceTreeFromUnknownDevice(filterDeviceTreeFromDuplicates(removeGroupFromTree(action.path, getTreeItems(device_tree, devices), device_tree)), devices);
        case 'RENAME_GROUP_IN_DEVICE_TREE':
            return filterDeviceTreeFromUnknownDevice(filterDeviceTreeFromDuplicates(changeGroupName(action.path, action.newTitle, getTreeItems(device_tree, devices), device_tree)), devices);
        case 'ADD_DEVICE_IN_GROUP_IN_DEVICE_TREE': {
            const filter_device_tree = filterDeviceTreeFromUnknownDevice(filterDeviceTreeFromDuplicates(device_tree), devices);
            const data_for_add_device = {
                parentPath: action.path,
                treeData: getTreeItems(filter_device_tree, devices),
                device_tree: filter_device_tree,
            };
            return addDeviceInGroup(data_for_add_device, action.device_id);
        }
        case 'EXPAND_GROUP_IN_DEVICE_TREE': {
            const filter_device_tree = filterDeviceTreeFromUnknownDevice(filterDeviceTreeFromDuplicates(device_tree), devices);
            const data_for_expanding_group = {
                expanded: action.expand,
                path: action.path,
                treeData: getTreeItems(filter_device_tree, devices),
                node: {},
            };
            return expandingGroup(data_for_expanding_group, device_tree);
        }
        case 'MOVE_ITEM_IN_DEVICE_TREE': {
            const filter_device_tree = filterDeviceTreeFromUnknownDevice(filterDeviceTreeFromDuplicates(device_tree), devices);
            const data_for_move_item = {
                treeData: action.new_tree_data,
                node: {},
                path: action.new_path,
                treeIndex: 0,
                nextPath: action.new_path,
                nextParentNode: {},
                nextTreeIndex: 0,
                prevPath: action.old_path,
                prevTreeIndex: 0,
            };
            return moveItem(data_for_move_item, deviceTreeWithLostDevices(filter_device_tree, devices), getTreeItems(filter_device_tree, devices));
        }
        case 'REMOVE_DEVICE_IN_DEVICE_TREE': {
            return filterDeviceTreeFromUnknownDevice(filterDeviceTreeFromDuplicates(device_tree), devices);
        }
        default:
            return device_tree;
    }
};
